import { render, staticRenderFns } from "./ExportDispatchDestination.vue?vue&type=template&id=619df89c&scoped=true"
import script from "./ExportDispatchDestination.vue?vue&type=script&lang=js"
export * from "./ExportDispatchDestination.vue?vue&type=script&lang=js"
import style0 from "./ExportDispatchDestination.vue?vue&type=style&index=0&id=619df89c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619df89c",
  null
  
)

export default component.exports